export const resources = {
  junior: {
    macos: [
      { name: 'iOS Development Guide', url: 'https://developer.apple.com/ios/', type: 'platform' },
      { name: 'Swift Programming Language', url: 'https://docs.swift.org/swift-book/', type: 'language' },
      { name: 'React Native Documentation', url: 'https://reactnative.dev/docs/getting-started', type: 'framework' },
      { name: 'Xcode User Guide', url: 'https://developer.apple.com/xcode/', type: 'tools' }
    ],
    windows: [
      { name: 'Android Development Guide', url: 'https://developer.android.com/guide', type: 'platform' },
      { name: 'Kotlin Programming', url: 'https://kotlinlang.org/docs/', type: 'language' },
      { name: 'Flutter Documentation', url: 'https://docs.flutter.dev/', type: 'framework' },
      { name: 'Android Studio Guide', url: 'https://developer.android.com/studio/intro', type: 'tools' }
    ],
    linux: [
      { name: 'Android Development on Linux', url: 'https://developer.android.com/studio/install', type: 'platform' },
      { name: 'Flutter on Linux', url: 'https://docs.flutter.dev/get-started/install/linux', type: 'framework' },
      { name: 'React Native CLI', url: 'https://reactnative.dev/docs/environment-setup', type: 'tools' },
      { name: 'Cordova Documentation', url: 'https://cordova.apache.org/docs/', type: 'framework' }
    ]
  },
  mid: {
    macos: [
      { name: 'iOS Architecture Patterns', url: 'https://developer.apple.com/documentation/swift/cocoa_design_patterns', type: 'architecture' },
      { name: 'Core Data Programming Guide', url: 'https://developer.apple.com/library/archive/documentation/Cocoa/Conceptual/CoreData/', type: 'data' },
      { name: 'SwiftUI Advanced Concepts', url: 'https://developer.apple.com/tutorials/swiftui', type: 'ui' },
      { name: 'App Store Connect Guide', url: 'https://developer.apple.com/app-store-connect/', type: 'distribution' }
    ],
    windows: [
      { name: 'Android Architecture Components', url: 'https://developer.android.com/topic/libraries/architecture', type: 'architecture' },
      { name: 'Room Database Guide', url: 'https://developer.android.com/training/data-storage/room', type: 'data' },
      { name: 'Jetpack Compose', url: 'https://developer.android.com/jetpack/compose', type: 'ui' },
      { name: 'Google Play Console', url: 'https://developer.android.com/distribute/console', type: 'distribution' }
    ],
    linux: [
      { name: 'Cross-platform Architecture', url: 'https://docs.flutter.dev/development/data-and-backend/state-mgmt', type: 'architecture' },
      { name: 'Mobile CI/CD Patterns', url: 'https://docs.github.com/en/actions/deployment/deploying-to-your-cloud-provider', type: 'deployment' },
      { name: 'Mobile Performance Optimization', url: 'https://web.dev/mobile/', type: 'performance' },
      { name: 'Progressive Web Apps', url: 'https://web.dev/progressive-web-apps/', type: 'web' }
    ]
  },
  senior: {
    macos: [
      { name: 'iOS Performance Best Practices', url: 'https://developer.apple.com/videos/performance/', type: 'performance' },
      { name: 'iOS Security Guide', url: 'https://developer.apple.com/documentation/security', type: 'security' },
      { name: 'App Store Review Guidelines', url: 'https://developer.apple.com/app-store/review/guidelines/', type: 'compliance' },
      { name: 'iOS Accessibility Programming Guide', url: 'https://developer.apple.com/accessibility/', type: 'accessibility' }
    ],
    windows: [
      { name: 'Android Performance Patterns', url: 'https://developer.android.com/topic/performance', type: 'performance' },
      { name: 'Android Security Best Practices', url: 'https://developer.android.com/topic/security/best-practices', type: 'security' },
      { name: 'Google Play Policy', url: 'https://play.google.com/about/developer-content-policy/', type: 'compliance' },
      { name: 'Android Accessibility', url: 'https://developer.android.com/guide/topics/ui/accessibility', type: 'accessibility' }
    ],
    linux: [
      { name: 'Mobile DevOps Best Practices', url: 'https://docs.microsoft.com/en-us/azure/devops/pipelines/ecosystems/mobile', type: 'devops' },
      { name: 'Cross-platform Security', url: 'https://owasp.org/www-project-mobile-top-10/', type: 'security' },
      { name: 'Mobile Analytics and Monitoring', url: 'https://firebase.google.com/docs/analytics', type: 'analytics' },
      { name: 'Enterprise Mobile Management', url: 'https://docs.microsoft.com/en-us/mem/', type: 'enterprise' }
    ]
  }
};
